import React, { useState, useRef } from 'react';
import bannerNuevo1 from '../../../assets/barners/BANNERS-WEB-BIOMERCY-1.png';
import bannerNuevo2 from '../../../assets/barners/BANNERS-WEB-BIOMERCY-2.png';
import bannerNuevo3 from '../../../assets/barners/BANNERS-WEB-BIOMERCY-3.png'; // 🔹 nuevo banner
import FarmacoCarouselModal from '../../../shared/modals/FarmacoCarouselModal';
import FarmacoFormModal from '../../../shared/navigation/navegation/FarmacoModal';
import TopBanner from './TopBanner';
import '../styles/home.css';

const Home = () => {
  const [showFarmacoModal, setShowFarmacoModal] = useState(false);
  const [showFarmacoFormModal, setShowFarmacoFormModal] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(0);

  const topRef = useRef(null);

  // 🔹 ahora con 3 banners
  const banners = [bannerNuevo1, bannerNuevo2, bannerNuevo3];
  const bannerColors = ['#9f8bb3', '#f3c058', '#f8f7f7']; // 🔹 color de fondo del 3er banner

  const handleAbrirFarmacoFormulario = () => {
    setShowFarmacoFormModal(true);
    topRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // const handleAbrirFarmacoModal = () => {
  //   setShowFarmacoModal(true);
  //   topRef.current?.scrollIntoView({ behavior: 'smooth' });
  // };

  const handlePreviousBanner = () => {
    setCurrentBanner(prev => (prev > 0 ? prev - 1 : 0));
  };

  const handleNextBanner = () => {
    setCurrentBanner(prev => (prev < banners.length - 1 ? prev + 1 : prev));
  };

  return (
    <>
      <TopBanner theme="home" currentBanner={currentBanner} />

      <div className="hero-container" ref={topRef}>
        <div className="hero-content">
          <div
            className="main-product-image"
            style={{
              background: `linear-gradient(to bottom, #ffffff 50%, ${bannerColors[currentBanner]} 70%)`,
              marginTop: '-100px',
            }}
          >
            <img
              src={banners[currentBanner]}
              alt={`Productos BIOMERCY ${currentBanner + 1}`}
              className={`product-background-img ${currentBanner === 2 ? 'banner-3' : ''}`}
            />
          </div>

          {/* Botón FARMACOVIGILANCIA flotante */}
          {/* <div
            className="farmacovigilancia-floating-btn"
            onClick={handleAbrirFarmacoModal}
          >
            FARMACOVIGILANCIA
          </div> */}

          {/* Botones de navegación */}
          {currentBanner > 0 && (
            <button
              className="carousel-nav-btn carousel-nav-prev"
              onClick={handlePreviousBanner}
              aria-label="Banner anterior"
            >
              &lt;
            </button>
          )}
          {currentBanner < banners.length - 1 && (
            <button
              className="carousel-nav-btn carousel-nav-next"
              onClick={handleNextBanner}
              aria-label="Banner siguiente"
            >
              &gt;
            </button>
          )}

          {/* Indicadores */}
          <div className="carousel-indicators">
            {banners.map((_, index) => (
              <button
                key={index}
                className={`carousel-indicator ${currentBanner === index ? 'active' : ''}`}
                onClick={() => setCurrentBanner(index)}
                aria-label={`Ir al banner ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Modales */}
        <FarmacoCarouselModal
          visible={showFarmacoModal}
          onClose={() => setShowFarmacoModal(false)}
          onAbrirFarmacoModal={handleAbrirFarmacoFormulario}
        />

        {showFarmacoFormModal && (
          <FarmacoFormModal
            visible={showFarmacoFormModal}
            onClose={() => setShowFarmacoFormModal(false)}
          />
        )}
      </div>
    </>
  );
};

export default Home;
